"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _automationHooks = require("@airportlabs/automation-hooks");
var _ = require("../");
var _excluded = ["value", "onChange", "withSign", "hideDoneButton", "onDoneClick", "automationHook"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var propTypes = {
  /** The value for the component */
  value: _propTypes["default"].shape({
    hours: _propTypes["default"].number,
    minutes: _propTypes["default"].number,
    seconds: _propTypes["default"].number,
    sign: _propTypes["default"].oneOf([-1, 1])
  }),
  /** Function to set the value object when one of the time inputs is changed  */
  onChange: _propTypes["default"].func.isRequired,
  /** When `true` it will output a select for the +/- sign. By default it's false. Use this prop to render the sign selector. */
  withSign: _propTypes["default"].bool,
  /** Wether to hide the done button next to the input. */
  hideDoneButton: _propTypes["default"].bool,
  /** What to execute when the done button is clicked. */
  onDoneClick: _propTypes["default"].func,
  /** Hook used for automation testing */
  automationHook: _propTypes["default"].string
};
exports.propTypes = propTypes;
var DurationInput = function DurationInput(props) {
  return /*#__PURE__*/_react["default"].createElement(_.Input, _extends({
    type: "number",
    placeholder: "hh",
    maxLength: "3",
    min: "0",
    w: "70px"
  }, props));
};
var DurationPickerBase = function DurationPickerBase(_ref) {
  var _value$sign$toString, _value$sign;
  var value = _ref.value,
    _onChange = _ref.onChange,
    _ref$withSign = _ref.withSign,
    withSign = _ref$withSign === void 0 ? false : _ref$withSign,
    _ref$hideDoneButton = _ref.hideDoneButton,
    hideDoneButton = _ref$hideDoneButton === void 0 ? false : _ref$hideDoneButton,
    onDoneClick = _ref.onDoneClick,
    automationHook = _ref.automationHook,
    rest = _objectWithoutProperties(_ref, _excluded);
  var durationInputRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    durationInputRef.current.focus();
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_.Box, {
    d: "flex",
    alignItems: "center",
    gap: "xs"
  }, withSign && /*#__PURE__*/_react["default"].createElement(_.Select, {
    w: "auto",
    value: (_value$sign$toString = value === null || value === void 0 ? void 0 : (_value$sign = value.sign) === null || _value$sign === void 0 ? void 0 : _value$sign.toString()) !== null && _value$sign$toString !== void 0 ? _value$sign$toString : 1,
    onChange: function onChange(e) {
      return _onChange(_objectSpread(_objectSpread({}, value), {}, {
        sign: parseInt(e.target.value, 10)
      }));
    },
    automationHook: (0, _automationHooks.getHook)(automationHook, "sign")
  }, /*#__PURE__*/_react["default"].createElement("option", _extends({
    value: "1"
  }, (0, _automationHooks.hook)(automationHook, "positive")), "+"), /*#__PURE__*/_react["default"].createElement("option", _extends({
    value: "-1"
  }, (0, _automationHooks.hook)(automationHook, "negative")), "-")), /*#__PURE__*/_react["default"].createElement(DurationInput, {
    placeholder: "hh",
    forwardedRef: durationInputRef,
    value: value === null || value === void 0 ? void 0 : value.hours,
    onChange: function onChange(e) {
      return _onChange(_objectSpread(_objectSpread({}, value), {}, {
        hours: parseInt(e.target.value, 10)
      }));
    },
    automationHook: (0, _automationHooks.getHook)(automationHook, "hour-input")
  }), /*#__PURE__*/_react["default"].createElement(_.Text, null, ":"), /*#__PURE__*/_react["default"].createElement(DurationInput, {
    placeholder: "mm",
    max: "59",
    value: value === null || value === void 0 ? void 0 : value.minutes,
    onChange: function onChange(e) {
      return _onChange(_objectSpread(_objectSpread({}, value), {}, {
        minutes: parseInt(e.target.value, 10)
      }));
    },
    automationHook: (0, _automationHooks.getHook)(automationHook, "minutes-input")
  }), /*#__PURE__*/_react["default"].createElement(_.Text, null, ":"), /*#__PURE__*/_react["default"].createElement(DurationInput, {
    placeholder: "ss",
    max: "59",
    value: value === null || value === void 0 ? void 0 : value.seconds,
    onChange: function onChange(e) {
      return _onChange(_objectSpread(_objectSpread({}, value), {}, {
        seconds: parseInt(e.target.value, 10)
      }));
    },
    automationHook: (0, _automationHooks.getHook)(automationHook, "seconds-input")
  }), !hideDoneButton && /*#__PURE__*/_react["default"].createElement(_.PrimaryButton, {
    onClick: onDoneClick,
    w: "70px",
    automationHook: (0, _automationHooks.getHook)(automationHook, "done-button")
  }, "Done"));
};
DurationPickerBase.propTypes = propTypes;
var _default = DurationPickerBase;
exports["default"] = _default;